import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField/index';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {TableRow, TableCell, Table, TableHead, TableBody } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Component styles
import styles from './styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Grid } from '@material-ui/core';
import {api_host, api_auth} from '../../../../common/globals/constants';
import {getThresholdNotification} from '../../../../services/getThresholdNotification'


const sendValues = (value, d, sno, snp, sng, h, snla, emn, emx, objetivo_id, token, notificacion, data, user, admin_id) => {
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/alertas/?token=${token}`, {
                method: method, // or 'PUT'
                body: JSON.stringify({token: token, objetivo_id: objetivo_id, notificacion: notificacion, 
                                        d: d, sno: sno, snp: snp, sng: sng, h: h, snla: snla, emn: emn, 
                                        emx: emx, data: data, user: user, admin: admin_id}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};

class NotificationsObjective extends Component {

    constructor(props) {
        super(props);
        //console.log("noti", props)
        this.state = {
            props: props,
            settingsEl: null,
            value: this.props.value,
			updateDisabled: true,
			dataError: false,
            isLoading: true,
            listObjective: this.props.listObjective,
            horarios: sessionStorage.getItem('user_schedules'),
            destinatarios: sessionStorage.getItem('user_addressee'),
            alertobjectives: this.props.alertobjectives,
            min: 1,
            max: 10,
            checkedGlobal: false,
            checkedUptime: false,
            checkedParcial: false,
            checkedUmbral: false,
            limit: false,
            limitUpdate: false,
            objetivo_id: this.props.objective,
            horario: 0,
            open: false,
            isValid: false,
            minUpdate: 0,
            maxUpdate: 0,
            checkedGlobalUpdate: false,
            checkedUptimeUpdate: false,
            checkedParcialUpdate: false,
            checkedUmbralUpdate: false,
            destinatarioUpdate: 0,
            horarioUpdate: 0,
            valueTab: 0,
            data: {},
            isLoading: true,
            valueAtmobilleModal:0
        }
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState[field] = value;   
        if(field == "checkedUmbral" && value == true){
            newState["checkedParcial"] = true;
        }else if (field == "checkedUmbral" && value == false )
        {
            newState["checkedParcial"] = false;
        }
        this.setState(newState);
    };

    handleFieldChangeTab = (field, value, valueTab, i) => {
        const newState = { ...this.state };
        newState['data'][valueTab].data[i].umbral = parseInt(value); 
        this.setState(newState);
    };
    
    handleSaved = async (value) => {

		let user = sessionStorage.getItem('user')
        let admin_id = sessionStorage.getItem('admin_id')
        let listDestinatarios = JSON.parse(this.state.destinatarios)
        let d = listDestinatarios[0].notificacion_destinatario_id
        let sno = null
        let snp = null
        let sng = null
        let h = null
        let snla = null
        let emn = null
        let emx = null
        let token = sessionStorage.getItem('key')
        let notificacion = null
        let data = null

        if (this.state.value == 1){
            if (this.state.destinatario){
                d = this.state.destinatario
            }
            sno = this.state.checkedUptime
            snp = this.state.checkedParcial
            sng = this.state.checkedGlobal
            h = this.state.horario
            snla = this.state.checkedUmbral
            emn = this.state.min
            emx = this.state.max 
            if (this.state.limit){
                emx = 'null'
            }
            data = this.state.data
        } else if (this.state.value == 2){
            d = this.state.destinatario
            sno = this.state.checkedUptimeUpdate
            snp = this.state.checkedParcialUpdate
            sng = this.state.checkedGlobalUpdate
            h = this.state.horario
            snla = this.state.checkedUmbralUpdate
            emn = this.state.minUpdate
            emx = this.state.maxUpdate
            if (this.state.limitUpdate){
                emx = 'null'
            }
            notificacion = this.props.alertobjectives.notificacion_id
            data = this.state.data
        }
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(this.state.value, d, sno, snp, sng, h, snla, emn, emx, this.state.objetivo_id, token, notificacion, data, user, admin_id);
            if (ok){
                this.setState({
                    isLoading: false,
                    isValid: true,                   
                    open: true
                });
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true
                });
            }

        } catch (error) {
            
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
        /*sessionStorage.clear()
        try {
            const { history } = this.props;
            const { values } = this.state;
            this.setState({ isLoading: true });
            await signIn(values.email, values.password);
            if(sessionStorage.length>1){
                localStorage.setItem('isAuthenticated', true);
                history.push('/quickview');
            }else{
                this.setState({
                    isLoading: false,
                    isValid:false,
                    touched:{
                        email:false,
                        password:false,
                    },
                    open: true
                });
            }
            
        } catch (error) {
            this.setState({
                isLoading: false,
                serviceError: error,
                isValid:false,
                open: true
            });
        }*/
    };
    
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
	};



    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return {
                value: nextProps.value,
                updateDisabled: true
            }
        }
    }
    componentDidUpdate(){
        //this.processData()
    }

    componentDidMount(){
        this.processData()
    }

    processData() {
        const {objetivo_id} = this.state;
        let token = sessionStorage.getItem('key')
        var getData = getThresholdNotification(objetivo_id, token) 
        getData.then( data =>  { 
            if(this.props.value == 2 && this.state.updateDisabled) {
                this.setState({
                    minUpdate: this.props.alertobjectives.envia_desde,
                    maxUpdate: this.props.alertobjectives.envia_hasta,
                    checkedGlobalUpdate: this.props.alertobjectives.alerta_global,
                    checkedUptimeUpdate: this.props.alertobjectives.alerta_uptime_ok,
                    checkedParcialUpdate: this.props.alertobjectives.alerta_parcial,
                    checkedUmbralUpdate: this.props.alertobjectives.alerta_sla,
                    destinatarioUpdate: this.props.alertobjectives.notificacion_destinatario.notificacion_destinatario_id,
                    horarioUpdate: this.props.alertobjectives.horario_id,
                    updateDisabled: false,
                    data: data,
                    isLoading: false
                })
            } else {
                this.setState({
                    data: data,
                    isLoading: false
                })
            }
            for (let i = 0; i < data.length; i++) {
                const valorServicio =data[i]['servicio_modal']
                const valorServicioId =valorServicio
                const valorServicioValidador =[55,255,256,257,258,270,271,272,1100]
                if(!valorServicioValidador.includes(valorServicioId)){
                    this.setState({
                        valueAtmobilleModal:1
                    })
                }
            }
        })

          
        
    }

    handleChange = (event, newValue) => {
        this.setState({
            valueTab: newValue,
            //updateDisabled: true,
            //: null
        });
    };


    render() {
        const { classes, className, alertobjectives, ...rest } = this.props;
        const { value, listobjective, horarios, destinatarios, min, max, limit, limitUpdate, open, isValid, minUpdate,
            maxUpdate, checkedGlobalUpdate, checkedUptimeUpdate, checkedParcialUpdate, checkedUmbralUpdate, destinatarioUpdate,
            horarioUpdate, checkedGlobal, checkedUptime, checkedParcial, checkedUmbral, data, valueTab, isLoading, valueAtmobilleModal } = this.state;
        const rootClassName = classNames(classes.root, className);
        let listHorarios = JSON.parse(horarios)
        let listDestinatarios = JSON.parse(destinatarios)   
        if (!isLoading) {
            return (
            
                <Portlet
                    {...rest}
                    className={rootClassName}
                >
                    <PerfectScrollbar>
                        <PortletHeader>
                            <PortletLabel
                                subtitle="Administre sus Alertas"
                                title="Alertas"
                            />
                        </PortletHeader>
                        {value == 1 ?
                            <PortletContent noPadding>
                                <form className={classes.form}>
                                    <div className={classes.group}>                        
                                        <FormControl className={classes.formControl}> 
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Destinatario
                                            </InputLabel>
                                            <NativeSelect
                                                className={classes.textFieldSelect}
                                                onChange={event =>
                                                    this.handleFieldChange('destinatario', event.target.value)
                                                }
                                                defaultValue={0}
                                                inputProps={{
                                                    name: 'name',
                                                    id: 'uncontrolled-native',
                                                }}
                                            >
                                                {Object.keys(listDestinatarios).map((key) => (
                                                    <option value={listDestinatarios[key].notificacion_destinatario_id}>{listDestinatarios[key].destinatario+' - '+listDestinatarios[key].nombre}</option>

                                                ))}
                                            </NativeSelect>
                                        </FormControl> 
                                        <FormControl className={classes.formControl}> 
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Horario
                                            </InputLabel>
                                            <NativeSelect
                                                className={classes.textFieldSelect}
                                                onChange={event =>
                                                    this.handleFieldChange('horario', event.target.value)
                                                }
                                                defaultValue={0}
                                                inputProps={{
                                                    name: 'name',
                                                    id: 'uncontrolled-native',
                                                }}
                                            >
                                                {Object.keys(listHorarios).map((key) => (
                                                    <option value={listHorarios[key].horario_id}>{listHorarios[key].nombre}</option>

                                                ))}
                                        
                                            </NativeSelect>
                                        </FormControl> 
                                        <Divider className={classes.profileDivider} />
                                        <div>
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Escabilidad
                                            </InputLabel>
                                            <Typography style={{fontSize:'10px'}} variant="caption">Define el rango de eventos downtime consecutivos en los que se deben disparar alertas.</Typography>
                                        </div>  
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>                      
                                                <div className={classes.field}>     
                                                    <Typography style={{marginRight:'5px'}} variant="body1">Desde</Typography>
                                                    <input id="min" min="1" max="9999999999" type="number" value={ min } 
                                                        onChange={event =>this.handleFieldChange('min', event.target.value)} disabled={limit}/>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>   
                                                <div className={classes.field}> 
                                                    <Typography style={{marginRight:'5px'}} variant="body1">Hasta</Typography>
                                                    <input id="max" min="1" max="9999999999" type="number" value={max} 
                                                        onChange={event =>this.handleFieldChange('max', event.target.value)} disabled={limit}/>  
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                xl={2}> 
                                                <div className={classes.field2}>  
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            onChange={event =>this.handleFieldChange('limit', event.target.checked)}
                                                        />   
                                                    <Typography variant="body1">Sin Límite</Typography> 
                                                </div> 
                                            </Grid>
                                        </Grid>
                                        <Divider className={classes.profileDivider} />
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>                                         
                                                <div className={classes.field}>
                                                    <Checkbox 
                                                        color="primary" 
                                                        checked={checkedGlobal}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedGlobal', event.target.checked)
                                                        }
                                                        />
                                                    <div>
                                                        <Typography variant="body1">Alerta Global</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de alertas de eventos downtime cuando se detecta un error desde todos </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">los ISP monitoreados. El envío de alerta depende de la escalabilidad y del horario elegido.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>  
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedParcial}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedParcial', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">Alerta Parcial</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de alertas de eventos downtime cuando se detecta un error en cualquier de los </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">ISP monitoreados. El envío de alerta depende de la escalabilidad y del horario elegido.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedUptime}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUptime', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">Alerta Uptime</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de una notificación cuando se pase de un downtime global y/o parcial a uptime, </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">siempre y cuando haya sido generada una alerta anteriormente.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        {valueAtmobilleModal == 0 ?
                                            <Grid
                                                container
                                                spacing={0}>    
                                                <Grid
                                                    item
                                                    xs={3}
                                                    sm={3}
                                                    md={3}
                                                    xl={3}>   
                                                    <div className={classes.field}>
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            checked={checkedUmbral}
                                                            onChange={event =>
                                                                this.handleFieldChange('checkedUmbral', event.target.checked)
                                                            }
                                                        />
                                                        <div>
                                                            <Typography variant="body1">Alerta Umbral</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={9}
                                                    sm={9}
                                                    md={9}
                                                    xl={9}>
                                                        <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                            <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de una alerta cada vez que el tiempo que demore alguno de los pasos del </Typography>
                                                            <Typography style={{fontSize:'10px'}} variant="caption">monitoreo sea mayor al configurado, independiente de si el resultado es UPTIME o DOWNTIME.**Se activará por defecto, la opción Alerta Parcial</Typography>
                                                        </div>
                                                </Grid>
                                            </Grid>
                                        :null}
                                        {checkedUmbral ?
                                            <div className={classes.root}>
                                                <Divider className={classes.profileDivider} />
                                                <AppBar position="static">
                                                    <Tabs scrollButtons="auto" value={valueTab} onChange={this.handleChange} aria-label="simple tabs example">
                                                        {data.map((key) => (
                                                            <Tab label={key.monitor.nombre_nodo}  />
                                                        ))}
                                                    </Tabs>
                                                </AppBar>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell></TableCell>
                                                            <TableCell>Nombre</TableCell>
                                                            <TableCell>Umbral</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data[valueTab].pasos.map((key, i) => (
                                                            <TableRow>
                                                                <TableCell>{key.orden}</TableCell>
                                                                <TableCell>{key.nombre}</TableCell>
                                                                <TableCell><input id="umbral" type="number" value={data[valueTab].data[i].umbral} 
                                                                    onChange={event =>this.handleFieldChangeTab('umbral', event.target.value, valueTab, i)}/> 
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        :null}
                                    </div>
                                </form>
                            </PortletContent>
                            /*Seccion Update*/
                        :   <PortletContent noPadding>
                                <form className={classes.form}>
                                    <div className={classes.group}>
                                        <FormControl className={classes.formControl}> 
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Destinatario
                                            </InputLabel>
                                            <NativeSelect
                                                className={classes.textFieldSelect}
                                                onChange={event =>
                                                    this.handleFieldChange('destinatarioUpdate', event.target.value)
                                                }
                                                //defaultValue={destinatarioUpdate}
                                                value={destinatarioUpdate}
                                                inputProps={{
                                                    name: 'name',
                                                    id: 'uncontrolled-native',
                                                }}
                                            >
                                                {Object.keys(listDestinatarios).map((key) => (
                                                    <option value={listDestinatarios[key].notificacion_destinatario_id}>{listDestinatarios[key].destinatario}</option>
                                                ))}
                                            </NativeSelect>
                                        </FormControl>   
                                        <FormControl className={classes.formControl}> 
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Horario
                                            </InputLabel>
                                            <NativeSelect
                                                className={classes.textFieldSelect}
                                                onChange={event =>
                                                    this.handleFieldChange('horarioUpdate', event.target.value)
                                                }
                                                //defaultValue={horarioUpdate}
                                                value={horarioUpdate}
                                                inputProps={{
                                                    name: 'name',
                                                    id: 'uncontrolled-native',
                                                }}
                                            >
                                                {Object.keys(listHorarios).map((key) => (
                                                    <option value={listHorarios[key].horario_id}>{listHorarios[key].nombre}</option>
                                                ))}
                                            </NativeSelect>
                                        </FormControl>  
                                        <Divider className={classes.profileDivider} />
                                        <div>
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                Escabilidad
                                            </InputLabel>
                                            <Typography style={{fontSize:'10px'}} variant="caption">Define el rango de eventos downtime consecutivos en los que se deben disparar alertas.</Typography>
                                        </div>   
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>                  
                                                    <div className={classes.field}>     
                                                        <Typography style={{marginRight:'5px'}} variant="body1">Desde</Typography>
                                                        <input id="minUpdate" min="1" max="9999999999" type="number" value={ minUpdate } 
                                                            onChange={event =>this.handleFieldChange('minUpdate', event.target.value)}/>
                                                    </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                xl={3}>   
                                                    <div className={classes.field}>  
                                                        <Typography style={{marginRight:'5px'}} variant="body1">Hasta</Typography>
                                                        <input id="maxUpdate" min="1" max="9999999999" type="number" value={ maxUpdate } 
                                                            onChange={event =>this.handleFieldChange('maxUpdate', event.target.value)} disabled={limitUpdate}/>                                    
                                                            
                                                    </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                xl={2}> 
                                                    <div className={classes.field2}>  
                                                        <Checkbox
                                                            color="primary"
                                                            //defaultChecked
                                                            onChange={event =>this.handleFieldChange('limitUpdate', event.target.checked)}
                                                        />   
                                                        <Typography variant="body1">Sin Límite</Typography> 
                                                    </div> 
                                            </Grid>
                                        </Grid> 
                                        <Divider className={classes.profileDivider} />
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>                                         
                                                <div className={classes.field}>
                                                    <Checkbox 
                                                        color="primary" 
                                                        checked={checkedGlobalUpdate}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedGlobalUpdate', event.target.checked)
                                                        }
                                                        />
                                                    <div>
                                                        <Typography variant="body1">Alerta Global</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de alertas de eventos downtime cuando se detecta un error desde todos </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">los ISP monitoreados. El envío de alerta depende de la escalabilidad y del horario elegido.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>  
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedParcialUpdate}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedParcialUpdate', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">Alerta Parcial</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de alertas de eventos downtime cuando se detecta un error en cualquier de los </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">ISP monitoreados. El envío de alerta depende de la escalabilidad y del horario elegido.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={checkedUptimeUpdate}
                                                        //defaultChecked
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUptimeUpdate', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">Alerta Uptime</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de una notificación cuando se pase de un downtime global y/o parcial a uptime, </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">siempre y cuando haya sido generada una alerta anteriormente.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}>    
                                            <Grid
                                                item
                                                xs={3}
                                                sm={3}
                                                md={3}
                                                xl={3}>   
                                                <div className={classes.field}>
                                                    <Checkbox
                                                        color="primary"
                                                        //defaultChecked
                                                        checked={checkedUmbralUpdate}
                                                        onChange={event =>
                                                            this.handleFieldChange('checkedUmbralUpdate', event.target.checked)
                                                        }
                                                    />
                                                    <div>
                                                        <Typography variant="body1">Alerta Umbral</Typography>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={9}
                                                sm={9}
                                                md={9}
                                                xl={9}>
                                                    <div style={{marginTop:'16px', marginBottom:'16px'}}>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">Activa el envío de una alerta cada vez que el tiempo que demore alguno de los pasos del </Typography>
                                                        <Typography style={{fontSize:'10px'}} variant="caption">monitoreo sea mayor al configurado, independiente de si el resultado es UPTIME o DOWNTIME.</Typography>
                                                    </div>
                                            </Grid>
                                        </Grid>
                                        
                                        {checkedUmbralUpdate ?
                                            <div className={classes.root}>
                                                <Divider className={classes.profileDivider} />
                                                <AppBar position="static">
                                                    <Tabs scrollButtons="auto" value={valueTab} onChange={this.handleChange} aria-label="simple tabs example">
                                                        {data.map((key) => (
                                                            <Tab label={key.monitor.nombre_nodo}  />
                                                        ))}
                                                    </Tabs>
                                                </AppBar>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell></TableCell>
                                                            <TableCell>Nombre</TableCell>
                                                            <TableCell>Umbral</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data[valueTab].pasos.map((key, i) => (
                                                            <TableRow>
                                                                <TableCell>{key.orden}</TableCell>
                                                                <TableCell>{key.nombre}</TableCell>
                                                                <TableCell><input id="umbralUpdate" min="1" max="9999999999" type="number" value={data[valueTab].data[i] !== undefined ? data[valueTab].data[i].umbral : 'empty'} 
                                                                    onChange={event =>this.handleFieldChangeTab('umbralUpdate', event.target.value, valueTab, i)}/> 
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        :null}
                                    </div>
                                </form>
                            </PortletContent>}
                            <Snackbar
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    open={open}
                                    autoHideDuration={6000}
                                    onClose={this.handleClose}
                                >
                                    <SnackbarContent
                                        className={isValid ? classes.snackContentOk
                                                    : classes.snackContent}
                                        aria-describedby="client-snackbar"
                                        message={
                                            
                                                isValid ?
                                                    <span id="client-snackbar" className={classes.message}>
                                                        <CheckCircleIcon className={(classes.icon, classes.iconVariant)}/>
                                                        Proceso Exitoso
                                                    </span>
                                                :	<span id="client-snackbar" className={classes.message}>
                                                        <ErrorIcon className={(classes.icon, classes.iconVariant)}/>
                                                        Ha ocurrido un error, intente nuevamente
                                                    </span>
                                            
                                        }
                                        action={[
                                            <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleClose}>
                                                <CloseIcon className={classes.icon}/>
                                            </IconButton>
                                        ]}
                                    />
                            </Snackbar>
                        <PortletFooter className={classes.portletFooter} align="right">
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={this.handleSaved}
                            >
                                Guardar
                            </Button>
                        </PortletFooter>
                    </PerfectScrollbar>
                </Portlet>
            );
        } else  {
           return( 
            <div >
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            style={{color:"white"}}
                            align="center"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={34}
                            thickness={4}                            
                            />
                            <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>)
        }
        
    }
}

NotificationsObjective.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotificationsObjective);
